import React, { useRef, useEffect, useLayoutEffect } from 'react'
import useInterval from '@use-it/interval'
import useWindowSize from 'src/shared/service/use_window_size.jsx'
import useScrollbarVisibility from 'src/shared/service/use_scrollbar_visibility'
import {Switch, Route, useLocation } from "react-router-dom"; 

export function usePinnedImageMapNavigation(desktopNavigationRef) {

  const windowSize = useWindowSize()
  const scrollbarVisibility = useScrollbarVisibility()
  let bgImage = document.getElementById("image-map-background-image")
  //const desktopNavigationRef?.current = desktopNavigationRef?.current
  const location = useLocation()
  
  const resizeObserver = new ResizeObserver((entries) => {
    checkPinnedPosition()
  })

  const mutationObserver = new MutationObserver((entries) => {
    checkPinnedPosition()
  })

  useLayoutEffect(() => {
    if(bgImage) {
      resizeObserver.observe(bgImage);
      mutationObserver.observe(bgImage, { attributes: true});
    }
    //alert("MOBILE NAVIGATION RENDERING NOT IMPLEMENTED")
    window.addEventListener('scroll', checkPinnedPosition);
    return () => {
      if(bgImage && resizeObserver) {
        resizeObserver.unobserve(bgImage);
        mutationObserver.disconnect();
      }
      window.removeEventListener('scroll', checkPinnedPosition);
    }
  }, [resizeObserver, checkPinnedPosition, mutationObserver])


  const checkPinnedPosition = (e) => {
    setTimeout(() => {
    bgImage = document.getElementById("image-map-background-image")

    if(!desktopNavigationRef?.current) {
      console.log("No ref found for usePinnedImageMapNavigation")
      return
    }


    if(bgImage && bgImage?.clientHeight && desktopNavigationRef?.current && bgImage?.clientHeight > 0) {

      const lowerBrowserViewPortPosition = window.scrollY + window.innerHeight

      console.log("------------------------------------------------------------------")
      console.log("bgImage?.clientHeight", bgImage?.clientHeight)
      console.log("lowerBrowserViewPortPosition", lowerBrowserViewPortPosition)
      console.log("desktopNavigationRef?.current.clientHeight", desktopNavigationRef?.current.clientHeight)

      if(lowerBrowserViewPortPosition > bgImage.clientHeight) {
        desktopNavigationRef.current.style.position = "absolute"
        desktopNavigationRef.current.style.top = String(bgImage.clientHeight - 0 - 10) + "px"
        desktopNavigationRef.current.style.bottom = null
        console.log("Pinning", bgImage.clientHeight, desktopNavigationRef?.current.clientHeight, String(bgImage.clientHeight - desktopNavigationRef?.current.clientHeight - 10) + "px")
      } else {
        console.log("UnPinning")
        desktopNavigationRef.current.style.position = "fixed"
        desktopNavigationRef.current.style.top = null
        desktopNavigationRef.current.style.bottom = "10px"
      }
    } else {
      desktopNavigationRef.current.style.position = "fixed"
      desktopNavigationRef.current.style.top = null
      desktopNavigationRef.current.style.bottom = "10px"
      console.log("Setting fixed navigation")
    }
  }, 250)
  }

  //useInterval(checkPinnedPosition, 250)
  useLayoutEffect(checkPinnedPosition, [scrollbarVisibility, windowSize, bgImage, bgImage?.attr?.["src"], desktopNavigationRef?.current, bgImage?.clientHeight, desktopNavigationRef?.current, desktopNavigationRef?.current?.clientHeight, location])

  return <></>
}
